import { render, staticRenderFns } from "./EyeDetailCard.vue?vue&type=template&id=3af9e30b"
import script from "./EyeDetailCard.vue?vue&type=script&lang=js"
export * from "./EyeDetailCard.vue?vue&type=script&lang=js"
import style0 from "./EyeDetailCard.vue?vue&type=style&index=0&id=3af9e30b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports